import { render, staticRenderFns } from "./AddTemplateModal.vue?vue&type=template&id=6d78ec88&"
import script from "./AddTemplateModal.vue?vue&type=script&lang=js&"
export * from "./AddTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports